(function () {
  'use strict';

  if (window.__wudyMobileInit) return;
  window.__wudyMobileInit = true;

  function headerOffset() {
    var header = document.querySelector('.wudy-header, .section-header, header.header');
    var h = header ? header.getBoundingClientRect().height : 0;
    if (!h) {
      var raw = getComputedStyle(document.documentElement).getPropertyValue('--wudy-header-offset');
      h = parseFloat(raw) || 100;
    }
    return Math.ceil(h + 6);
  }

  function setHeaderOffsetVar() {
    var header = document.querySelector('.wudy-header');
    var shell = document.querySelector('sticky-group-manager') || document.querySelector('.shopify-section.section-header');
    if (header) {
      var height = Math.ceil(header.getBoundingClientRect().height);
      if (height > 0) {
        document.documentElement.style.setProperty('--wudy-header-offset', height + 'px');
        if (shell) shell.style.minHeight = height + 'px';
      }
    }
    document.documentElement.style.setProperty('--wudy-scroll-offset', headerOffset() + 'px');
  }

  function scrollToAnchor(el, behavior) {
    if (!el) return;
    var top = el.getBoundingClientRect().top + (window.scrollY || window.pageYOffset) - headerOffset();
    var isTouch =
      window.matchMedia('(hover: none)').matches || window.matchMedia('(pointer: coarse)').matches;
    var resolved = behavior || (isTouch ? 'auto' : 'smooth');
    window.scrollTo({ top: Math.max(0, top), behavior: resolved });
  }

  function initHashAnchors() {
    if (!location.hash || location.hash.length < 2) return;
    var id = decodeURIComponent(location.hash.slice(1));
    var target = document.getElementById(id);
    if (!target) return;

    function align() {
      scrollToAnchor(target, 'instant');
    }

    if (document.readyState === 'complete') {
      requestAnimationFrame(function () {
        requestAnimationFrame(align);
      });
    } else {
      window.addEventListener('load', align, { once: true });
    }
  }

  function initFormFabHide() {
    if (!('IntersectionObserver' in window)) return;

    var targets = document.querySelectorAll('#leave-a-note, [data-wudy-form-in-view]');
    if (!targets.length) return;

    var pending = false;
    var visible = new WeakSet();

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && entry.intersectionRatio > 0.1) visible.add(entry.target);
          else visible.delete(entry.target);
        });
        if (pending) return;
        pending = true;
        requestAnimationFrame(function () {
          pending = false;
          var any = false;
          targets.forEach(function (el) {
            if (visible.has(el)) any = true;
          });
          document.body.classList.toggle('wudy-form-in-view', any);
          document.body.classList.toggle('wudy-leave-form-visible', any && !!document.getElementById('leave-a-note'));
        });
      },
      { root: null, rootMargin: '0px 0px -10% 0px', threshold: [0.1] }
    );

    targets.forEach(function (el) {
      io.observe(el);
    });
  }

  function init() {
    setHeaderOffsetVar();
    initHashAnchors();
    initFormFabHide();
    window.addEventListener('resize', setHeaderOffsetVar, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
